import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, switchMap, tap, shareReplay, map, of, catchError, BehaviorSubject, timer, delay, filter } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../ngrx/template/template.reducers';
import * as DataActions from '../../ngrx/data/data.actions';
import { ModalService } from '../modal/modal.service';
import { environment } from '../../environment/environment';
import { ActivatedRoute } from '@angular/router';
import { ListRequestDTO } from '../../dto/list-request.dto';
import { ListResponseDTO } from '../../dto/list-response.dto';
import { DashboardDataRequestDTO } from '../../dto/dashboard/dashboard-data-request.dto';
// Import the getUserProgressData function
import { getUserProgressData } from '../dashboard/data/user-progress.data';

// Data sources
//import { status_oevelser_beredskabsstyrelsen } from './data/old/status_oevelser_beredskabsstyrelsen';
import { dunaUsers } from './data/cprng/dunaUsers';
//import { status_oevelser_organisation } from './data/old/status_oevelser_organisation';
//import { status_oevelser_lokale } from './data/old/status_oevelser_lokale';
//import { status_events_gennemfoerte } from './data/old/status_events_gennemfoerte';
import { add_event_users } from './data/event/old_add-event-users';
import { add_event_materials } from './data/event/add-event-materials';
import { brugere_status } from './data/brugere_status';
import { duna_users } from './data/duna_users';
import { email_conflicts } from './data/email_conflicts';
import { add_event_documents } from './data/event/add-event-documents';
import { audit_logs_all } from './data/audit_log/audit_logs_all';
import { audit_logs_events } from './data/audit_log/audit_logs_events';
import { audit_logs_user } from './data/audit_log/audit_logs_user';
import { yearly_sticker_status } from './data/yearly_sticker_status';
//import { event_requirements } from './data/old/event_requirements';
import { event_participation } from './data/event/old_event_participation';
import { event_search } from './data/event/event_search';
import { event_calendar } from './data/event/event_calendar';
//import { event_statistics } from './data/old/event_statistics';
import { user_upcoming_events } from './data/user_upcoming_events';
import { FunctionRegistryService } from '../function-registry/function-registry.service';
import { PushNotificationService } from '../push-notification/push-notification.service';
import { subtypes } from './data/educational-path/subtypes';
import { Router, NavigationEnd } from '@angular/router';
import { events } from './data/event/events';
import { group_calendar_events } from './data/events/group_calendar_events';
import { group_calendar_stats } from './data/events/group_calendar_stats';
import { goals } from './data/educational-path/goals';
import { modules } from './data/educational-path/modules';
import { moduleVersions } from './data/educational-path/module-versions';
import { moduleData } from './data/educational-path/module-data';
import { educationalPaths } from './data/educational-path/educational-paths';
import { educationalPathRequirements } from './data/educational-path/educational-path-requirements';
import { educationalPathMaintenance } from './data/educational-path/educational-path-maintenance';
import { educationalPathUsers } from './data/educational-path/educational-path-users';
import { EducationalPathDTO } from '../../dto/educational-path/educational-path.dto';
import { educationalPathItems } from './data/educational-path/educational-path-items';
import { LoadDataParams } from '../../interfaces/DataSource/DataSourceParams.interface';
import { FacetFilterConfig, mapFacetsToTableFilters } from '../../interfaces/DataSource/FacetFilterConfig.interface';
import { dual_panel_subtypes } from './data/dual-panel-subtypes';
import { rls_tables } from './data/cprng/rls-tables';
import { rls_policies } from './data/cprng/rls-policies';
import { dual_panel_roles } from './data/dual-panel-roles';
import { profile_paths_brs } from './data/profile/profile-paths-brs';
import { profile_paths_organization } from './data/profile/profile-paths-organization';
import { profile_paths_location } from './data/profile/profile-paths-location';
import { profile_paths_competence } from './data/profile/profile-paths-competence';
import { profile_paths_completed } from './data/profile/profile-paths-completed';
import { dual_panel_unassigned_users } from './data/dual-panel-unassigned-users';
import { locations } from './data/locations/locations';
import { locations_suggested } from './data/locations/locations_suggested';
import { locations_suggested_admin } from './data/locations/locations_suggested_admin';
import { locations_admin } from './data/locations/locations_admin';
import { rooms } from './data/locations/rooms';
import { rooms_admin } from './data/locations/rooms_admin';
import { locations_users } from './data/locations/locations_users';
import { dual_panel_modules } from './data/dual-panel-modules';
import { locations_rooms } from './data/locations/locations-rooms';
import { event_participants } from './data/event/event_participants';
import { event_instructors } from './data/event/event_instructors';
import { event_available_users } from './data/event/event-available-users';
import { event } from './data/event/event';
import { event_waitlist } from './data/event/event_waitlist';
import { event_cancellations } from './data/event/event_cancellations';
import { event_form_data } from './data/event/event_form_data';
import { event_price_templates } from './data/event/event_price_templates';
import { event_price_groups } from './data/event/event_price_groups';
import { event_price_extra_options } from './data/event/event_price_extra_options';
import { event_additional_rooms_field_visible } from './data/event/event_additional_rooms_field_visible';
import { event_catering_field_visible } from './data/event/event_catering_field_visible';
import { event_modules_page_visible } from './data/event/event_modules_page_visible';
import { event_category_field_visible } from './data/event/event_category_field_visible';
import { event_category_choices } from './data/event/event_category_choices';
import { event_org_resources } from './data/event/event_org_resources';
import { event_org_resources_field_visible } from './data/event/event_org_resources_field_visible';
import { event_participate_form_data } from './data/event/event_participate_form_data';
import { event_allow_register_others } from './data/event/event_allow_register_others';
import { event_disallow_register_others } from './data/event/event_disallow_register_others';
import { event_allow_cancel_24h } from './data/event/event_allow_cancel_24h';
import { event_show_catering_page } from './data/event/event_show_catering_page';
import { event_register_deadline_visible } from './data/event/event_register_deadline_visible';
import { event_extra } from './data/event/event_extra';
import { dual_panel_users } from './data/dual_panel_users';
import { external_users } from './data/external_users';
import { educationalPathVersions } from './data/educational-path/educational-path-versions';
import { orgPathVersions } from './data/educational-path/org-path-versions';
import { event_users_not_assigned } from './data/event/event-users-not-assigned';
import { events_with_catering } from './data/event/events_with_catering';
import { duna_catering_pending } from './data/event/duna_catering_pending';
import { duna_catering_approved } from './data/event/duna_catering_approved';
import { duna_catering_unique_pending } from './data/event/duna_catering_unique_pending';
import { duna_catering_unique_approved } from './data/event/duna_catering_unique_approved';
import { duna_cleaning_unique_future } from './data/event/duna_cleaning_unique_future';
import { duna_cleaning_unique_past } from './data/event/duna_cleaning_unique_past';
import { events_needing_instructors } from './data/event/events_needing_instructors';
import { instructor_invitations_list } from './data/event/instructor_invitations_list';
import { instructor_invitation_detail } from './data/event/instructor_invitation_detail';
import { location_events } from './data/locations/location-events';
import { profile_user_events } from './data/profile/profile_user_events';
import { profile_user_ep_wizard } from './data/profile/profile_user_ep_wizard';
import { profile_manual_maintenance_minutes } from './data/profile/profile_manual_maintenance_minutes';
import { PROFILE_URL_SCOPED_DATA_SOURCE_KEYS } from './data/profile/profile-url-scoped-datasource.util';
import { templates } from './data/templates';
import { UserService } from '../user/user.service';
import { RequestQueueService } from '../request-queue/request-queue.service';

// Import advisory data sources
import { advisories } from './data/advi/advisories';
import { advisoryDetail } from './data/advi/advisory-detail';
import { org_settings } from './data/organizations/org-settings';
import { cprng_features } from './data/organizations/cprng-features';
import { cprng_endpoints } from './data/organizations/cprng-endpoints';
import { org_customer_archive_enabled } from './data/organizations/org-customer-archive-enabled';
import { duna_groups_enabled } from './data/organizations/org-groups-enabled';
import { duna_group_calendar_enabled } from './data/organizations/org-group-calendar-enabled';
import { duna_materials_enabled } from './data/organizations/org-materials-enabled';
import { duna_user_group_calendar_visible } from './data/organizations/org-user-group-calendar-visible';
import { customers } from './data/customers/customers';
import { duna_customers } from './data/customers/duna_customers';
import { duna_user_groups } from './data/groups/duna_user_groups';
import { duna_user_groups_location } from './data/groups/duna_user_groups_location';
import { duna_customer_events } from './data/customers/duna_customer_events';

export interface DataSourceFunction {
  name: string;
  description?: string;
  execute: (params?: LoadDataParams) => Observable<any>;
  settings?: any;
}

interface FilterableData {
  items: any[];
  totalCount: number;
  pageSize?: number;
  pageIndex?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ComponentDataSourceService {
  private dataSourceRegistry = new Map<string, DataSourceFunction>();
  private registeredDataSources: string[] = [];
  private currentPathData$: Observable<EducationalPathDTO | null> | null = null;
  public readonly apiUrl = environment.apiUrl;
  private currentVersionIdSubject = new BehaviorSubject<string | null>(null);
  private lastProfileUrlUserUuid: string | null = null;
  /** Last table load params per data source (sort, pagination, search) for refresh after mutations */
  private lastLoadParamsByKey = new Map<string, LoadDataParams>();

  constructor(
    public http: HttpClient, 
    public authService: AuthService, 
    public functionRegistryService: FunctionRegistryService, 
    public pushNotificationService: PushNotificationService,
    public store: Store<AppState>,
    private router: Router,
    public injector: Injector,
    public modalService: ModalService,
    private route: ActivatedRoute,
    private requestQueueService: RequestQueueService
  ) {
    // Register built-in data sources
    this.registerDataSource('dunaUsers', dunaUsers(this));
    /*this.registerDataSource('status_oevelser_beredskabsstyrelsen', status_oevelser_beredskabsstyrelsen(this));
    this.registerDataSource('status_oevelser_organisation', status_oevelser_organisation(this));
    this.registerDataSource('status_oevelser_lokale', status_oevelser_lokale(this));
    this.registerDataSource('status_events_gennemfoerte', status_events_gennemfoerte(this));*/
    this.registerDataSource('add_event_users', add_event_users(this));
    this.registerDataSource('add_event_materials', add_event_materials(this));
    this.registerDataSource('brugere_status', brugere_status(this, this.http, this.router));
    this.registerDataSource('duna_users', duna_users(this, this.http, this.router, this.authService));
    this.registerDataSource('email_conflicts', email_conflicts(this, this.http, this.router));
    this.registerDataSource('add_event_documents', add_event_documents(this));
    
    // Register audit log data sources
    this.registerDataSource('audit_logs_all', audit_logs_all(this, this.http, this.router));
    this.registerDataSource('audit_logs_events', audit_logs_events(this, this.http, this.router));
    this.registerDataSource('audit_logs_user', audit_logs_user(this, this.http, this.router));
    this.registerDataSource('event_users_not_assigned', event_users_not_assigned(this, this.http, this.router));
    this.registerDataSource('events_with_catering', events_with_catering(this, this.http, this.router));
    this.registerDataSource('duna_catering_pending', duna_catering_pending(this));
    this.registerDataSource('duna_catering_approved', duna_catering_approved(this));
    this.registerDataSource('duna_catering_unique_pending', duna_catering_unique_pending(this));
    this.registerDataSource('duna_catering_unique_approved', duna_catering_unique_approved(this));
    this.registerDataSource('duna_cleaning_unique_future', duna_cleaning_unique_future(this));
    this.registerDataSource('duna_cleaning_unique_past', duna_cleaning_unique_past(this));
    this.registerDataSource('events_needing_instructors', events_needing_instructors(this));
    this.registerDataSource('instructor_invitations_list', instructor_invitations_list(this));
    this.registerDataSource('instructor_invitation_detail', instructor_invitation_detail(this));

    // Register new data sources
    this.registerDataSource('yearly_sticker_status', yearly_sticker_status(this));
    //this.registerDataSource('event_requirements', event_requirements(this));
    this.registerDataSource('event_participation', event_participation(this));
    this.registerDataSource('event_search', event_search(this));
    this.registerDataSource('event_calendar', event_calendar(this));
    //this.registerDataSource('event_statistics', event_statistics(this));
    this.registerDataSource('user_upcoming_events', user_upcoming_events(this));
    

    // Register new event system data sources
    this.registerDataSource('events', events(this));
    this.registerDataSource('subtypes', subtypes(this, this.functionRegistryService));
    this.registerDataSource('goals', goals(this, this.functionRegistryService));
    this.registerDataSource('modules', modules(this, this.functionRegistryService));
    this.registerDataSource('module_versions', moduleVersions(this, this.functionRegistryService));
    this.registerDataSource('module_data', moduleData(this, this.functionRegistryService));
    this.registerDataSource('educational_paths', educationalPaths(this, this.functionRegistryService));

    // Register educational path detail data sources
    this.registerDataSource('educational_path_requirements', educationalPathRequirements(this, this.functionRegistryService));
    this.registerDataSource('educational_path_maintenance', educationalPathMaintenance(this, this.functionRegistryService));
    this.registerDataSource('educational_path_users', educationalPathUsers(this, this.functionRegistryService));
    this.registerDataSource('educational_path_versions', educationalPathVersions(this));
    this.registerDataSource('org_path_versions', orgPathVersions(this));

    // Register educational path items
    this.registerDataSource('educational_path_items', educationalPathItems);

    // Register dual panel data sources
    this.registerDataSource('subtypes_special', dual_panel_subtypes(this));
    this.registerDataSource('dual_panel_subtypes', dual_panel_subtypes(this));
    this.registerDataSource('dual_panel_modules', dual_panel_modules(this));
    this.registerDataSource('dual_panel_roles', dual_panel_roles(this));
    this.registerDataSource('dual_panel_unassigned_users', dual_panel_unassigned_users(this));
    this.registerDataSource('dual_panel_users', dual_panel_users(this, this.http, this.router));
    this.registerDataSource('external_users', external_users(this, this.http, this.router));

    // Add a special monitor data source for debugging
    this.registerDataSource('monitor_subtypes', {
      name: 'Monitor Subtypes',
      description: 'Monitoring data source for debugging dual panel subtypes',
      execute: (params?: any) => {
        
        // Use the proper dual_panel_subtypes data source but with extra logging
        const originalDS = dual_panel_subtypes(this);
        return originalDS.execute(params).pipe(
          tap(result => {
          })
        );
      }
    });

    // Register RLS data sources
    this.registerDataSource('rls_tables', rls_tables(this));
    this.registerDataSource('rls_policies', rls_policies(this));

    // Register profile data sources
    this.registerDataSource('profile_paths_brs', profile_paths_brs(this));
    this.registerDataSource('profile_paths_organization', profile_paths_organization(this));
    this.registerDataSource('profile_paths_location', profile_paths_location(this));
    this.registerDataSource('profile_paths_competence', profile_paths_competence(this));
    this.registerDataSource('profile_paths_completed', profile_paths_completed(this));
    this.registerDataSource('profile_user_events', profile_user_events(this, this.http, this.router, this.injector.get(UserService)));
    this.registerDataSource('profile_user_ep_wizard', profile_user_ep_wizard(this, this.http, this.router, this.injector.get(UserService)));
    this.registerDataSource('profile_manual_maintenance_minutes', profile_manual_maintenance_minutes(this, this.http, this.router, this.injector.get(UserService)));

    // Register location data sources
    this.registerDataSource('locations', locations(this));
    this.registerDataSource('locations_suggested', locations_suggested(this));
    this.registerDataSource('locations_suggested_admin', locations_suggested_admin(this));
    this.registerDataSource('locations_admin', locations_admin(this));
    this.registerDataSource('rooms', rooms(this));
    this.registerDataSource('rooms_admin', rooms_admin(this));
    this.registerDataSource('locations_rooms', locations_rooms(this));
    this.registerDataSource('locations_users', locations_users(this));
    this.registerDataSource('location_events', location_events(this));

    // Register dashboard data sources
    this.registerDataSource('userProgress', {
      name: 'User Progress Data',
      description: 'Dashboard widget data source for user progress',
      execute: (params?: any) => {
        // Use the imported getUserProgressData function directly
        return getUserProgressData(this.http, params?.filters || { group: 'all' });
      }
    });

    // Register userStatus data source for dashboard
    this.registerDataSource('userStatus', {
      name: 'User Status Data',
      description: 'Dashboard widget data source for user educational path status',
      execute: (params?: any) => {
        return this.fetchDashboardData('userStatus', {
          sourceType: 'userStatus',
          page: 1,
          pageSize: 100,
          filters: params?.filters || {},
          includeFilters: true
        });
      }
    });

    // Register event participation data sources
    this.registerDataSource('event_participants', event_participants(this));
    this.registerDataSource('event_instructors', event_instructors(this));
    this.registerDataSource('event_available_users', event_available_users(this));

    // Register event data sources
    this.registerDataSource('event', event(this));
    this.registerDataSource('event_waitlist', event_waitlist(this));
    this.registerDataSource('event_cancellations', event_cancellations(this));
    this.registerDataSource('event_form_data', event_form_data(this));
    this.registerDataSource('event_price_templates', event_price_templates(this));
    this.registerDataSource('event_price_groups', event_price_groups(this));
    this.registerDataSource('event_price_extra_options', event_price_extra_options(this));
    this.registerDataSource('event_additional_rooms_field_visible', event_additional_rooms_field_visible(this));
    this.registerDataSource('event_catering_field_visible', event_catering_field_visible(this));
    this.registerDataSource('event_modules_page_visible', event_modules_page_visible(this));
    this.registerDataSource('event_category_field_visible', event_category_field_visible(this));
    this.registerDataSource('event_category_choices', event_category_choices(this));
    this.registerDataSource('event_org_resources', event_org_resources(this));
    this.registerDataSource('event_org_resources_field_visible', event_org_resources_field_visible(this));
    this.registerDataSource('event_participate_form_data', event_participate_form_data(this));
    this.registerDataSource('event_allow_register_others', event_allow_register_others(this));
    this.registerDataSource('event_disallow_register_others', event_disallow_register_others(this));
    this.registerDataSource('event_allow_cancel_24h', event_allow_cancel_24h(this));
    this.registerDataSource('event_show_catering_page', event_show_catering_page(this));
    this.registerDataSource('event_register_deadline_visible', event_register_deadline_visible(this));
    this.registerDataSource('event_extra', event_extra(this));

    // Register new dual_panel_users data source
    this.registerDataSource('dual_panel_users', dual_panel_users(this, this.http, this.router));

    // Register educational path data sources
    this.registerDataSource('educational_path_versions', educationalPathVersions(this));
    this.registerDataSource('org_path_versions', orgPathVersions(this));

    // Register templates data source
    this.registerDataSource('templates', templates(this));
    this.registerDataSource('group_calendar_events', group_calendar_events(this));
    this.registerDataSource('group_calendar_stats', group_calendar_stats(this));

    // Register advisory data sources
    this.registerDataSource('advisories', advisories(this));
    this.registerDataSource('advisoryDetail', advisoryDetail(this));

    // Register organization settings data source
    this.registerDataSource('org_settings', org_settings(this));
    this.registerDataSource('cprng_features', cprng_features(this));
    this.registerDataSource('cprng_endpoints', cprng_endpoints(this));
    this.registerDataSource('org_customer_archive_enabled', org_customer_archive_enabled(this));
    this.registerDataSource('duna_groups_enabled', duna_groups_enabled(this));
    this.registerDataSource('duna_group_calendar_enabled', duna_group_calendar_enabled(this));
    this.registerDataSource('duna_materials_enabled', duna_materials_enabled(this));
    this.registerDataSource('duna_user_group_calendar_visible', duna_user_group_calendar_visible(this));

    // Register customer data sources
    this.registerDataSource('customers', customers(this));
    this.registerDataSource('duna_customers', duna_customers(this));
    this.registerDataSource('duna_user_groups', duna_user_groups(this));
    this.registerDataSource('duna_user_groups_location', duna_user_groups_location(this));
    this.registerDataSource('duna_customer_events', duna_customer_events(this));

    // Ensure subtypes are registered
    this.ensureSubtypesDataSourceRegistered();
    
    // IMPORTANT: Restore the original subtypes data source to override the fallback
    // This ensures we're using the proper implementation with correct logging
    this.restoreOriginalSubtypesDataSource();

    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(() => {
      this.setCurrentVersionId(this.getCurrentVersionId());
      this.clearProfileUrlScopedCachesIfUserChanged();
    });

  }

  /** NgRx caches by data source key only; profile tables must refetch when URL user UUID changes. */
  private clearProfileUrlScopedCachesIfUserChanged(): void {
    const userService = this.injector.get(UserService);
    const profileUuid = userService.getCurrentUserUuid();
    if (profileUuid === this.lastProfileUrlUserUuid) {
      return;
    }
    const hadPreviousProfile = this.lastProfileUrlUserUuid !== null;
    this.lastProfileUrlUserUuid = profileUuid;
    if (!hadPreviousProfile && !profileUuid) {
      return;
    }
    for (const key of PROFILE_URL_SCOPED_DATA_SOURCE_KEYS) {
      this.store.dispatch(DataActions.clearData({ dataSourceKey: key }));
    }
  }

  registerDataSource(key: string, dataSource: DataSourceFunction): void {
    this.dataSourceRegistry.set(key, dataSource);

    if (!this.registeredDataSources.includes(key)) {
      this.registeredDataSources.push(key);
    }
  }

  getCurrentSlug(): string {
    try {
      const currentUrl = window.location.pathname;
      const parts = currentUrl.split('/').filter(Boolean);
      
      // Check if we're on an educational path page
      if (parts.includes('uddannelsesvej')) {
        // Get the index of 'uddannelsesvej' and take the next part as the GUID
        const uddannelsesvejIndex = parts.indexOf('uddannelsesvej');
        if (uddannelsesvejIndex >= 0 && parts[uddannelsesvejIndex + 1]) {
          return parts[uddannelsesvejIndex + 1];
        }
      }
      
      // Return the full path without leading or trailing slashes
      return parts.join('/').replace(/^\/+|\/+$/g, '') || 'unknown';
    } catch (error) {
      console.error('[ComponentDataSourceService] Error getting current slug:', error);
      return 'unknown';
    }
  }

  getEducationalPathData(): Observable<EducationalPathDTO | null> {
    
    if (!this.currentPathData$) {
      const guid = this.getCurrentSlug();
      if (!guid) {
        console.error('[ComponentDataSourceService] No GUID available for fetching educational path');
        return of(null);
      }
      
      // Use request queue to prevent too many simultaneous requests
      this.currentPathData$ = this.requestQueueService.queueRequest(() => 
        of(null).pipe(
          // Wait a bit for authentication to be ready
          delay(1000),
          // Check if we have authentication
          switchMap(() => {
            const token = this.authService.getToken();
            if (!token) {
              // Wait a bit more and try again
              return timer(3000).pipe(
                switchMap(() => {
                  const retryToken = this.authService.getToken();
                  if (!retryToken) {
                    console.error('[ComponentDataSourceService] Still no auth token after retry');
                    return of(null);
                  }
                  return this.http.get<EducationalPathDTO>(`${environment.apiUrl}/paths/${guid}`);
                })
              );
            }
            return this.http.get<EducationalPathDTO>(`${environment.apiUrl}/paths/${guid}`);
          }),
          tap(response => {
          }),
          catchError(error => {
            console.error('[ComponentDataSourceService] Error fetching educational path:', error);
            return of(null);
          }),
          shareReplay(1)
        )
      );
    }
    
    return this.currentPathData$;
  }

  clearEducationalPathData(): void {
    this.currentPathData$ = null;
  }

  refreshData(): void {
    this.clearEducationalPathData();
    this.store.dispatch(DataActions.refreshData());
  }

  getRegisteredDataSourceKeys(): string[] {
    return [...this.registeredDataSources];
  }

  getDataSource(key: string): DataSourceFunction | undefined {
    return this.dataSourceRegistry.get(key);
  }

  executeDataSource(key: string, ...args: any[]): Observable<any> | undefined {
    const dataSource = this.dataSourceRegistry.get(key);
    if (!dataSource) {
      console.error(`[ComponentDataSourceService] Data source '${key}' not found`);
      return undefined;
    }
    try {
      return dataSource.execute(...args);
    } catch (error) {
      console.error(`[ComponentDataSourceService] Error executing data source '${key}':`, error);
      return of({ items: [], totalCount: 0 });
    }
  }

  getDataSourceSettings(key: string): any | undefined {
    const dataSource = this.dataSourceRegistry.get(key);
    const settings = dataSource?.settings;
    if (settings?.pageSizeOptions) {
    }
    return settings;
  }

  private rememberLoadParams(dataSourceKey: string, params: LoadDataParams): void {
    if (!dataSourceKey) {
      return;
    }
    this.lastLoadParamsByKey.set(dataSourceKey, { ...params, dataSourceKey });
  }

  private buildStoreSettings(dataSourceKey: string, updatedData: any): any {
    const baseSettings =
      updatedData?.settings ?? this.getDataSourceSettings(dataSourceKey);
    const params = this.lastLoadParamsByKey.get(dataSourceKey);
    if (!baseSettings || !params?.sort?.active) {
      return baseSettings;
    }
    return {
      ...baseSettings,
      defaultSortColumn: params.sort.active,
      defaultSortDirection: params.sort.direction ?? 'asc',
    };
  }

  /**
   * Helper function to update store data after an operation
   * @param source$ The source observable (usually an HTTP operation)
   * @param dataSourceKey The key of the data source to refresh
   * @returns An observable that will emit the updated data
   */
  updateStoreData<T>(source$: Observable<T>, dataSourceKey: string): Observable<any> {
    return source$.pipe(
      switchMap(() => {
        const params = this.lastLoadParamsByKey.get(dataSourceKey);
        return this.loadDataWithFilters(dataSourceKey, params);
      }),
      tap(updatedData => {
        this.store.dispatch(DataActions.loadDataSuccess({
          dataSourceKey,
          data: updatedData,
          settings: this.buildStoreSettings(dataSourceKey, updatedData)
        }));
      })
    );
  }

  // Method to handle data loading with filtering
  loadDataWithFilters(dataSourceKey: string, params?: LoadDataParams): Observable<any> {
    const dataSource = this.getDataSource(dataSourceKey);
    if (!dataSource) {
      throw new Error(`Data source ${dataSourceKey} not found`);
    }

    // When no sort is provided, apply data source default sort so the API returns sorted data
    let effectiveParams = params ?? { dataSourceKey };
    if (!effectiveParams.sort?.active) {
      const settings = this.getDataSourceSettings(dataSourceKey);
      if (settings?.defaultSortColumn) {
        effectiveParams = {
          ...effectiveParams,
          sort: {
            active: settings.defaultSortColumn,
            direction: (settings.defaultSortDirection === 'desc' ? 'desc' : 'asc') as 'asc' | 'desc'
          }
        };
      }
    }

    this.rememberLoadParams(dataSourceKey, effectiveParams);

    // Prepare query parameters for server-side operations
    const queryParams: any = {};
    
    // Add search parameter
    if (effectiveParams?.searchQuery) {
      queryParams.searchQuery = effectiveParams.searchQuery;
    }

    // Add pagination parameters
    if (effectiveParams?.filters) {
      const pageSize = effectiveParams.filters.find((f: any) => f.column === 'pageSize')?.value;
      const pageIndex = effectiveParams.filters.find((f: any) => f.column === 'pageIndex')?.value;
      
      if (pageSize !== undefined) queryParams.pageSize = pageSize;
      if (pageIndex !== undefined) queryParams.pageIndex = pageIndex;

      // Add any additional filters that aren't pagination
      effectiveParams.filters
        .filter((f: any) => !['pageSize', 'pageIndex'].includes(f.column))
        .forEach((filter: any) => {
          if (filter.value != null && filter.value !== '') {
            queryParams[filter.column] = filter.value;
          }
        });
    }

    // Execute data source with server-side parameters
    return dataSource.execute({ 
      ...effectiveParams,
      queryParams,
      dataSourceKey 
    }).pipe(
      map((result) => this.enrichResultWithFacets(dataSourceKey, result))
    );
  }

  /**
   * Maps API facet response to table filter options and attaches to result settings.
   */
  private enrichResultWithFacets(dataSourceKey: string, result: any): any {
    if (!result) {
      return result;
    }

    const settings = this.getDataSourceSettings(dataSourceKey);
    const facetConfig = settings?.facetFilters as FacetFilterConfig | undefined;

    if (!facetConfig?.fields?.length) {
      return result;
    }

    const facets = result.facets ?? {};
    const existingFilters = result.filters ?? settings?.filters;
    const filters = mapFacetsToTableFilters(facets, facetConfig, existingFilters);

    return {
      ...result,
      facets: result.facets ?? facets,
      filters,
      settings: {
        ...settings,
        filters,
      },
    };
  }

  // Debug function to check subtypes data source registration
  public ensureSubtypesDataSourceRegistered(): void {
    
    // First, check if the subtypes data source is registered
    const registeredDataSourceKeys = this.registeredDataSources;
    
    // Only register fallback for dual panel variants
    const dualPanelVariants = ['dual_panel_subtypes', 'dual-panel-subtypes'];
    const hasDualPanelDataSource = dualPanelVariants.some(name => registeredDataSourceKeys.includes(name));
    
    // Create a fallback data source that explicitly uses the by-ids endpoint
    const fallbackSubtypesDS = {
      name: 'Subtypes Fallback',
      description: 'Fallback subtypes data source for dual panel selector',
      execute: (params?: any) => {
        
        // Get the base URL from environment or use default
        const apiUrl = environment.apiUrl;
        
        // ALWAYS check for IDs in both params.queryParams and params.filters
        const hasIdsInQuery = params?.queryParams?.ids !== undefined;
        const hasIdsInFilters = params?.filters && params.filters.some((f: any) => f.column === 'ids');
        
        
        // If we have IDs, ALWAYS use the by-ids endpoint
        if (hasIdsInQuery || hasIdsInFilters) {
          const ids = hasIdsInQuery 
            ? params.queryParams.ids 
            : params.filters.find((f: any) => f.column === 'ids').value.join(',');
            
          
          // Construct the URL manually to ensure it's correct
          const byIdsUrl = `${apiUrl}/events/subtypes/by-ids`;
          
          // Create query params explicitly
          const queryParams: any = { 
            ids: ids,
            includeSelectedIds: true
          };
          
          
          // Make direct HTTP request
          return this.http.get(byIdsUrl, { params: queryParams });
        } else {
          // For regular calls, use the standard endpoint
          return this.http.get(`${apiUrl}/events/subtypes`, 
            { params: params?.queryParams || {} });
        }
      }
    };
    
    // Only register with dual panel variants IF THEY DON'T EXIST
    dualPanelVariants.forEach(name => {
      // Check if it already exists
      if (!this.dataSourceRegistry.has(name)) {
        this.dataSourceRegistry.set(name, fallbackSubtypesDS);
        // Also store a direct reference in the service instance
        (this as any)[`${name}_dataSource`] = fallbackSubtypesDS;
        
        // Add to registered list if not there
        if (!this.registeredDataSources.includes(name)) {
          this.registeredDataSources.push(name);
        }
      } else {
      }
    });
    
  }

  // New method to restore the original dual panel subtypes data source
  public restoreOriginalSubtypesDataSource(): void {
    
    // Create a fresh instance of the proper data source
    const properDualPanelSubtypes = dual_panel_subtypes(this);
    
    // Register it to overwrite the fallback
    this.dataSourceRegistry.set('dual_panel_subtypes', properDualPanelSubtypes);
    
    // Also register our monitor for debugging
    this.dataSourceRegistry.set('dual_panel_subtypes_debug', {
      name: 'Subtypes Debug',
      description: 'Debug wrapper for dual panel subtypes',
      execute: (params?: any) => {
        return properDualPanelSubtypes.execute(params).pipe(
          tap(result => {
          })
        );
      }
    });
    
  }

  public getCurrentPathUuid(): string | null {
    const path = this.router.url.split('/');
    const uuidIndex = path.indexOf('uddannelsesvej') + 1;
    return uuidIndex > 0 && uuidIndex < path.length ? path[uuidIndex] : null;
  }

  public getCurrentVersionId(): string | null {
    const path = this.router.url.split('/');
    const versionIndex = path.indexOf('uddannelsesvej') + 2;
    
    // Check if the index is valid and the value is numeric (versions are always numeric IDs)
    if (versionIndex > 0 && versionIndex < path.length) {
      const potentialId = path[versionIndex];
      // Only return if it's a valid number
      if (/^\d+$/.test(potentialId)) {
        return potentialId;
      }
    }
    
    return null;
  }

  public setCurrentVersionId(versionId: string | null): void {
    if (this.currentVersionIdSubject.value !== versionId) {
      this.currentVersionIdSubject.next(versionId);
    }
  }

  public getCurrentVersionId$(): Observable<string | null> {
    return this.currentVersionIdSubject.asObservable();
  }

  /**
   * Load data with standardized filtering
   * @param dataSourceKey The key of the data source
   * @param endpoint The API endpoint to use
   * @param params Optional load parameters
   */
  loadDataWithStandardFilters(dataSourceKey: string, endpoint: string, params?: LoadDataParams): Observable<any> {
    const request = this.convertToListRequest(params, dataSourceKey);
    return this.fetchList(endpoint, request).pipe(
      map(response => this.convertToLegacyResponse(response))
    );
  }

  fetchDashboardData(dataSource: string, request: DashboardDataRequestDTO): Observable<any> {
    
    // Make sure to use the exact same URL format as in user-progress.data.ts
    const endpoint = `${this.apiUrl}/dashboard/data/${dataSource}`;
    
    // Use the correct path to match what's in user-progress.data.ts
    return this.http.post(endpoint, request).pipe(
      tap(response => {
        
        // Log structure details - use type assertion to fix linter errors
        const typedResponse = response as { data?: any[], meta?: any };
        
        if (typedResponse && Array.isArray(typedResponse.data)) {
          if (typedResponse.data.length > 0) {
          }
        } else {
        }
        
        // Log meta details
        if (typedResponse && typedResponse.meta) {
        }
      }),
      catchError(error => {
        console.error(`❌❌❌ [ComponentDataSourceService] ERROR fetching dashboard data for ${dataSource}:`, error);
        console.error(`❌ [ComponentDataSourceService] Error status: ${error.status}, message: ${error.message || 'Unknown error'}`);
        
        // Always provide a valid structure to prevent UI crashes
        return of({
          data: [],
          meta: {
            totalItems: 0,
            page: 1,
            pageSize: 10,
            totalPages: 0
          },
          filters: {}
        });
      })
    );
  }

  private fetchList<T = any>(endpoint: string, request: ListRequestDTO): Observable<ListResponseDTO<T>> {
    
    return this.http.post<ListResponseDTO<T>>(`${this.apiUrl}${endpoint}`, request);
  }

  /**
   * Converts legacy filter format to standardized ListRequestDTO
   */
  private convertToListRequest(params?: LoadDataParams, dataSourceKey?: string): ListRequestDTO {
    
    // Get default page size from data source settings, fallback to 10
    let defaultPageSize = 10;
    if (dataSourceKey) {
      const settings = this.getDataSourceSettings(dataSourceKey);
      if (settings && settings.pageSize) {
        defaultPageSize = settings.pageSize;
      }
    }
    
    const request: ListRequestDTO = {
      page: 1,
      pageSize: defaultPageSize
    };

    if (!params) {
      if (dataSourceKey) {
        const settings = this.getDataSourceSettings(dataSourceKey);
        if (settings?.facetFilters) {
          request.includeFacets = true;
        }
      }
      return request;
    }

    if (params.listRequest) {
      Object.assign(request, params.listRequest);
    }

    // Convert pagination params
    if (params.filters) {
      const pageIndex = params.filters.find(f => f.column === 'pageIndex')?.value;
      const pageSize = params.filters.find(f => f.column === 'pageSize')?.value;
      
      if (pageIndex !== undefined) {
        request.page = pageIndex + 1; // Convert from 0-based to 1-based
      }
      
      if (pageSize !== undefined) {
        request.pageSize = pageSize;
      }

      // Convert regular filters
      const filterObj: Record<string, any> = {};
      params.filters
        .filter(f => !['pageSize', 'pageIndex'].includes(f.column))
        .forEach(filter => {
          filterObj[filter.column] = filter.value;
        });
      
      if (Object.keys(filterObj).length > 0) {
        request.filters = filterObj;
      }
    }

    // Add search term
    if (params.searchQuery) {
      request.search = params.searchQuery;
    } else {
    }

    // Add sort parameters
    if (params.sort) {
      request.sortBy = params.sort.active;
      request.sortDir = params.sort.direction || 'asc';
    } else {
    }

    if (dataSourceKey) {
      const settings = this.getDataSourceSettings(dataSourceKey);
      if (settings?.facetFilters) {
        request.includeFacets = true;
      }
    }

    return request;
  }

  /**
   * Converts ListRequestDTO to query parameters for GET requests
   */
  private convertListRequestToQueryParams(request: ListRequestDTO): Record<string, string> {
    
    const params: Record<string, string> = {};

    // Basic pagination and sorting
    params['page'] = request.page.toString();
    params['pageSize'] = request.pageSize.toString();
    // QueryFilter reads pageIndex (0-based), not page
    params['pageIndex'] = (request.page - 1).toString();
    
    if (request.sortBy) {
      params['sortBy'] = request.sortBy;
    }
    
    if (request.sortDir) {
      params['sortDir'] = request.sortDir;
    }
    
    if (request.search) {
      params['search'] = request.search;
    } else {
    }
    
    if (request.includeFilters) {
      params['includeFilters'] = 'true';
    }

    if (request.includeFacets) {
      params['includeFacets'] = 'true';
    }

    // Convert filters to flat query parameters
    if (request.filters) {
      Object.entries(request.filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          params[`filter_${key}`] = String(value);
        }
      });
    }

    return params;
  }

  /**
   * Load data using GET request with query parameters (REST-compliant)
   */
  loadDataWithStandardFiltersGET(dataSourceKey: string, endpoint: string, params?: LoadDataParams): Observable<any> {
    const request = this.convertToListRequest(params, dataSourceKey);
    const queryParams = this.convertListRequestToQueryParams(request);
    
    return this.http.get<ListResponseDTO<any>>(`${this.apiUrl}${endpoint}`, { params: queryParams }).pipe(
      map(response => this.convertToLegacyResponse(response)),
      map(result => this.enrichResultWithFacets(dataSourceKey, result))
    );
  }

  /**
   * Converts a ListResponseDTO to the legacy format expected by components
   */
  private convertToLegacyResponse<T = any>(response: ListResponseDTO<T>): any {
    
    // Defensive check for proper ListResponseDTO format
    if (!response || !response.meta) {
      console.error('[convertToLegacyResponse] Invalid response format - missing meta:', response);
      return {
        items: Array.isArray(response) ? response : (response?.data || []),
        totalCount: 0,
        pageSize: 10,
        pageIndex: 0,
        filters: undefined
      };
    }
    
    return {
      items: response.data || [],
      totalCount: response.meta.totalItems || 0,
      pageSize: response.meta.pageSize || 10,
      pageIndex: (response.meta.page || 1) - 1, // Convert from 1-based to 0-based
      filters: response.filters,
      facets: response.facets,
      meta: response.meta
    };
  }
}
